export default __webpack_public_path__ + "static/media/Bad.6f212705.svg";